// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProcessHeader__header___swe0_ {
    height: 4.8rem;
    background-color: var(--color-bg-secondary);
}

.ProcessHeader__breadcrumbs___gnoDa {
    cursor: pointer;
    -webkit-user-select: none;
       -moz-user-select: none;
            user-select: none;
}
`, "",{"version":3,"sources":["webpack://./../GM.Frontend.Library/src/components/Template/ProcessHeader/ProcessHeader.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,2CAA2C;AAC/C;;AAEA;IACI,eAAe;IACf,yBAAiB;OAAjB,sBAAiB;YAAjB,iBAAiB;AACrB","sourcesContent":[".header {\n    height: 4.8rem;\n    background-color: var(--color-bg-secondary);\n}\n\n.breadcrumbs {\n    cursor: pointer;\n    user-select: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `ProcessHeader__header___swe0_`,
	"breadcrumbs": `ProcessHeader__breadcrumbs___gnoDa`
};
export default ___CSS_LOADER_EXPORT___;
